import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SharedService } from '../../shared/services/shared.service';
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { ILayoutSlot } from '../../interfaces/pass-layout/layout-slot';
import { ITemplateLayoutSection } from '../../interfaces/pass-layout/template-layout-section';
import { IPlatformTemplateLayouts } from '../../interfaces/pass-layout/platforrm-template-layouts';
import { IAssignedSlots } from '../../interfaces/pass-layout/assigned-slots';
import { DigitalWalletPlatform } from '../../enums/digital-wallet-platform';

@Injectable({
  providedIn: 'root'
})
export class PassLayoutService {

    private http = inject(HttpClient);
    private tokenStorageService = inject(TokenStorageService);
    private sharedService = inject(SharedService);
    private errorProcessorService = inject(ErrorProcessorService);

    private passTypesUrl = '/pass-admin/brands/{brandCode}/passes/pass-types';
    private platformTemplateLayoutsUrl = '/offer-admin/brands/{brandCode}/pass-layout-config/{passType}';
    private assignedSlotsUrl = '/offer-admin/brands/{brandCode}/pass-layout/{offerId}';
    
   constructor() { }

   // Find out distinct pass types used by the given brand.  In case we have more then one - prompt the user for a selection.
  getPassTypes(brandCode: string, baseUrl: string): Observable<string[]> {
    var url = baseUrl + this.passTypesUrl
      .replace('{brandCode}', brandCode);
    return this.http.get<string[]>(url, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Get the metadata for all three platforms: sections with available slots
  getPlatformTemplateLayouts(brandCode: string, passType: string, baseUrl: string): Observable<IPlatformTemplateLayouts> {
    var url = baseUrl + this.platformTemplateLayoutsUrl
      .replace('{brandCode}', brandCode)
      .replace('{passType}', passType);
    return this.http.get<IPlatformTemplateLayouts>(url, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  // Find out already assigned slots
  getAssignedSlots(brandCode: string, platform: string, offerId: number, baseUrl: string): Observable<IAssignedSlots> {
    var url = baseUrl + this.assignedSlotsUrl
      .replace('{brandCode}', brandCode)
      .replace('{platform}', platform)
      .replace('{offerId}', offerId.toString());
    return this.http.get<IAssignedSlots>(url, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }  

  // Submit assigned slots for all three platforrms
  submitAssignedSlots(brandCode: string, passType: string, offerId: number, baseUrl: string, assignedSlots: IAssignedSlots): Observable<string> {
    var url = baseUrl + this.assignedSlotsUrl
      .replace('{brandCode}', brandCode)
      .replace('{passType}', passType)
      .replace('{offerId}', offerId.toString());
    return this.http.put<string>(url, assignedSlots, {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }  


}


